import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useNavigate, useResolvedPath } from "react-router-dom";

const BreadcrumbOne = (props) => {
    const navigate = useNavigate();
    const resolved = useResolvedPath("/backend");

    return (
        <Breadcrumb>
            <Breadcrumb.Item
                href={resolved.pathname}
                onClick={(e) => {
                    e.preventDefault();
                    navigate("/backend");
                }}
            >
                หน้าหลัก
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{props?.name}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default BreadcrumbOne;
